import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { withFormik } from "formik"
import { InputTextarea } from "primereact/inputtextarea"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const Observaciones = ({
  handleSubmit,
  values,
  handleChange,
  onHide,
  isValid,
}: {
  handleSubmit: () => void
  values: { observaciones: string }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChange: $TSMigrationFixMe
  onHide: () => void
  isValid: boolean
}) => {
  const { t } = useTranslation()
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='observaciones'>
            {t("crear.facturaRec.modal.observationLabel")}
          </label>
          <InputTextarea
            autoFocus
            rows={5}
            cols={10}
            autoResize
            id='observaciones'
            name='observaciones'
            aria-describedby='username-help'
            value={values.observaciones}
            onChange={handleChange}
            autoComplete='off'
          />
        </div>
      </div>
      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer hover:!tw-shadow'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          disabled={!isValid}
          className='!tw-bg-primary tw-h-10 tw-flex tw-justify-center tw-items-center hover:!tw-shadow hover:!tw-bg-primary-over'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  observaciones: Yup.string().min(1).required(),
})

const FormObservacionesDocumento = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapPropsToValues: ({ observaciones }: $TSMigrationFixMe) => ({
    observaciones: observaciones ?? "",
  }),
  handleSubmit: ({ observaciones }, { props }) => {
    props.onChange(observaciones)
    props.onHide()
  },
})(Observaciones)

export default FormObservacionesDocumento
